import { render, staticRenderFns } from "./shipping-status-information.vue?vue&type=template&id=4f047622&"
import script from "./shipping-status-information.vue?vue&type=script&lang=js&"
export * from "./shipping-status-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports